import { RegexTypeEnum } from '@shared/enums';
import { UserInfo } from '@shared/interfaces';

export class SelectLabUserEmailHelper {
    static isEmailValid(selectedUserEmail: string | UserInfo): boolean {
        if (!selectedUserEmail) {
            return true;
        }

        return new RegExp(RegexTypeEnum.EMAIL_PATTERN).test(
            SelectLabUserEmailHelper.getStringFromSelectedUser(selectedUserEmail)
        );
    }

    static getStringFromSelectedUser(selectedUserEmail: string | UserInfo) {
        if (typeof selectedUserEmail === 'string') {
            return selectedUserEmail;
        } else {
            return selectedUserEmail.email;
        }
    }
}
